(function($) {
    'use strict';

    var Message = function(el) {
        this.$el = $(el);
        this.$close = this.$el.find('.message-close');
        this.id = this.$el.prop('id');
        this.init();
    };

    Message.prototype = {
        init: function() {
            var that = this;

            that.bindEvents();
            if (that.id.length === 0) {
                return;
            }

            if (!$.cookie(that.id)) {
                that.show();
            }
        },

        bindEvents: function() {
            var that = this;
            that.$close.on('click', function() {
                that.hide();
            });
        },

        show: function() {
            var that = this;

            that.$el.removeClass('initially-hidden');
        },

        hide: function() {
            var that = this;

            that.$el.fadeOut(function() {
                that.$el.remove();
                if (that.id) {
                    $.cookie(that.id, true);
                }
            });
        }
    };

    $.fn.message = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('message');

            if (!data) {
                $this.data('message', (data = new Message(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.message.Constructor = Message;
})(jQuery);
